import moment from 'moment';
import type { Many } from 'lodash';
import { get as _get } from 'lodash';

const isDate = (input: any) => moment(input, undefined, true).isValid();

const sortByProperty = <T extends object>(
  a: T,
  b: T,
  key: keyof T | Many<string | number | symbol>,
  reverse?: boolean,
): number => {
  const compareA = _get(a, key);
  const compareB = _get(b, key);

  if (typeof compareA !== typeof compareB) {
    throw new Error(
      `Error in sortBy. Values of different type. Got: ${compareA} and ${compareB}`,
    );
  }
  // Compare Strings
  if (typeof compareA === 'string' && typeof compareB === 'string') {
    const upperA = compareA.toUpperCase();
    const upperB = compareB.toUpperCase();
    if (upperA < upperB) return reverse ? 1 : -1;
    if (upperA > upperB) return reverse ? -1 : 1;
    return 0;
  }
  // Compare Numbers
  if (typeof compareA === 'number' && typeof compareB === 'number') {
    return reverse ? compareB - compareA : compareA - compareB;
  }

  // Compare Dates
  if (isDate(compareA) && isDate(compareB)) {
    if (moment(compareA).isAfter(moment(compareB))) {
      return reverse ? 1 : -1;
    }
    return reverse ? -1 : 1;
  }

  return 0;
};

export default sortByProperty;
